import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData_Kratos from "./NoData_Kratos";
import ChartLoader_Kratos from "./ChartLoader_Kratos";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BucketDischarge_Kratos from "./BucketDischarge_Kratos";
import WaterMark from "../../../componets/Dashboard/DashboardMain/WaterMark";

let labelsForPopup = ["20", "40", "60", "80", "100+"];

export default function SocDischargeCycle({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;
    let responce = {
      "<=20": 0,
      40: 0,
      60: 0,
      80: 0,
      100: 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        let value = d.median_dischargeSoc.values["50.0"];
        if (value <= 20) {
          responce["<=20"] = responce["<=20"] + 1;
        } else if (value > 20 && value <= 40) {
          responce["40"] = responce["40"] + 1;
        } else if (value > 40 && value <= 60) {
          responce["60"] = responce["60"] + 1;
        } else if (value > 60 && value <= 80) {
          responce["80"] = responce["80"] + 1;
        } else if (value > 80 && value <= 100) {
          responce["100"] = responce["100"] + 1;
        } else if (value >= 240) {
          responce[">240"] = responce[">240"] + 1;
        }
      });
      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys = ["<=20", "40", "60", "80", "100"];
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#83A4CF"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Average Soc Discharge",
      minValue: 0,
      format: "short",
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Vehicle Count",
      minValue: 0,
      format: "short",
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "kratos_drive/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox chartbox_kratos">
        <div className="titlebg_kratos text-fit">{title}</div>
        <div className="chartHGT">
          <WaterMark />
          {isLoading ? (
            <ChartLoader_Kratos />
          ) : chartdata.length == 0 ? (
            <NoData_Kratos />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="240px"
              data={chartdata}
              options={options}
              chartEvents={[
                {
                  eventName: "select",
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length === 1) {
                      const [selectedItem] = selection;
                      const { row } = selectedItem;

                      // const barvalue =
                      //   chartWrapper.getDataTable().Wf[row].c[0].v;
                      // const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                      // if (count != 0) {
                      //   let filtered_temp = [];
                      //   filtered_temp = apiresponce.filter((x) => {
                      //     if (
                      //       x.median_dischargeSoc.values["50.0"] <= barvalue &&
                      //       x.median_dischargeSoc.values["50.0"] > barvalue - 20
                      //     ) {
                      //       return x;
                      //     } else if (
                      //       x.median_dischargeSoc.values["50.0"] >= 240 &&
                      //       barvalue === ">240"
                      //     ) {
                      //       return x;
                      //     } else if (
                      //       x.median_dischargeSoc.values["50.0"] <= 20 &&
                      //       barvalue === "<=20"
                      //     ) {
                      //       return x;
                      //     }
                      //   });

                      //   function compareObjects(object1, object2, key) {
                      //     const obj1 =
                      //       object1.median_dischargeSoc.values["50.0"];
                      //     const obj2 =
                      //       object2.median_dischargeSoc.values["50.0"];
                      //     if (obj1 > obj2) {
                      //       return -1;
                      //     }
                      //     if (obj1 < obj2) {
                      //       return 1;
                      //     }
                      //     return 0;
                      //   }

                      // filtered_temp.sort((value1, value2) => {
                      //   return compareObjects(value1, value2, "vehicalId");
                      // });

                      let minRange = labelsForPopup[row - 1]
                      let maxRange = labelsForPopup[row]

                      const filteredData = apiresponce.filter((item) => {
                        const value = Number(item?.median_dischargeSoc.values["50.0"]);

                        if (row === 0) {
                          return value < Number(maxRange);
                        }

                        if (row === labelsForPopup.length - 1) {
                          return value > Number(minRange);
                        }

                        return value > Number(minRange) && value <= Number(maxRange);

                      });

                      SetfilteredData((prestate) => filteredData);
                      window.$("#exampleModal__" + apiend).modal("show");
                    }
                    // }
                  },
                },
              ]}
            />
          )}

          <div
            className="modal fade"
            id={"exampleModal__" + apiend}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {modal_title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
                <div className="modal-body">
                  {/* <table className="table table-striped">
                    <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">value</th>
                      </tr></thead>
                    <tbody> */}
                  <BucketDischarge_Kratos data={filteredData} />
                  {/* </tbody></table> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
